<h1 class="mb-2"><mdb-icon fas icon="cog"></mdb-icon> Módulos</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Configuración Usuarios</span>
      <span> /</span>
      <span>Módulos</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<div class="card mb-2 wow detalle-cliente">
  <div class="card-body">
    <div class="row filtros-header justify-content-end" style="border-bottom: 1px solid #dee2e6">
      <button type="button" mdbBtn color="info" (click)="showNew(); showModalAgregar()" size="sm" mdbWavesEffect>
        Agregar
      </button>
    </div>
    <div class="row filtros-body align-items-center">
      <div class="col" style="max-width: 150px">
        <div class="md-form mb-0">
          <input value="" type="text" id="bmodulo" [(ngModel)]="filtroNombre" class="form-contmodulo" placeholder="Modulo"
            required #modulo />
          <label for="modulo">Modulo</label>
        </div>
      </div>
    </div>
  </div>
  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
    <div></div>
    <button mdbBtn type="button" color="secondary" (click)="buscar()" size="sm" mdbWavesEffect>
      <mdb-icon fas icon="search"></mdb-icon> Buscar
    </button>
  </div>
</div>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <div class="table-responsive" *ngIf="moduloList">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Codigo</th>
            <th scope="col">Módulo</th>
            <th scope="col">EndPoint</th>
            <th scope="col">Categoria</th>
            <th scope="col">Orden</th>
            <th scope="col">Fecha de creación</th>
            <th scope="col">Bloqueo de concurrencia</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="100%" style="text-align: center">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </td>
          </tr>
          <tr *ngIf="!loading && moduloList?.length === 0">
            <td colspan="6" style="text-align: center">
              No se encontro informacion
            </td>
          </tr>
          <tr *ngFor="let mod of moduloList">
            <td>{{ mod.codigo }}</td>
            <td>{{ mod.nombre }}</td>
            <td style="max-width: 200px; white-space: pre-wrap">{{ mod.endpoint }}</td>
            <td>{{ mod.categoria_modulo_nombre }}</td>
            <td>{{ mod.orden }}</td>
            <td>{{ mod.fecha_creacion | date: "dd/MM/yyyy" }}</td>
            <td>
              <div *ngIf="mod.habilitar_bloqueo">
                <mdb-badge pill="true" success="true">SI</mdb-badge>
              </div>
              <div *ngIf="!mod.habilitar_bloqueo">
                <mdb-badge pill="true" warning="true">NO</mdb-badge>
              </div>
            </td>
            <td>
              <div *ngIf="mod.activado">
                <mdb-badge pill="true" success="true">Activo</mdb-badge>
              </div>
              <div *ngIf="!mod.activado">
                <mdb-badge pill="true" warning="true">Inactivo</mdb-badge>
              </div>
            </td>
            <td>
              <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                (click)="showForEdit(mod); showModalModificar()" mdbTooltip="Editar" placement="right">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
              <button *ngIf="mod.activado" mdbBtn type="button" size="sm" color="primary" mdbWavesEffect
                class="btn-actions-sm" (click)="permitirCambioEstado(mod)" mdbTooltip="Desactivar" placement="right">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <button *ngIf="!mod.activado" mdbBtn type="button" size="sm" color="success" mdbWavesEffect
                class="btn-actions-sm" (click)="permitirCambioEstado(mod)" mdbTooltip="Activar" placement="right">
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="moduloList?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar rol -->
<div mdbModal #agregarModulo="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <!-- Formulario -->
      <form [formGroup]="formulario" (ngSubmit)="insertar(operacionModuloList); agregarModulo.hide()">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="agregarModulo.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos de módulo
              </h5>
            </div>
            <div class="col">
              <div class="switch">
                <label>Inactivo<input formControlName="activado" type="checkbox" checked="" /><span
                    class="lever"></span>Activo</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input value="" formControlName="nombre" type="text" id="amodulo" placeholder="Módulo" required #rol
                  maxlength="50" />
                <label for="vecodigo">Módulo</label>
                <div *ngIf="
                    formulario.get('nombre').invalid &&
                    (formulario.get('nombre').dirty ||
                      formulario.get('nombre').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('nombre').hasError('required')">El Nombre es requerido.</mdb-error>
                  <mdb-error *ngIf="formulario.get('nombre').hasError('maxlength')">El Nombre no puede superar los 50
                    caracteres.</mdb-error>
                  <mdb-error *ngIf="formulario.get('nombre').hasError('minlength')">El Nombre debe tener como mínimo 5
                    caracteres.</mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input value="" formControlName="endpoint" type="text" id="aendpoint" class="form-control"
                  placeholder="Endpoint" required #endpoint maxlength="100" />
                <label for="endpoint">Endpoint</label>
                <div *ngIf="
                    formulario.get('endpoint').invalid &&
                    (formulario.get('endpoint').dirty ||
                      formulario.get('endpoint').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('endpoint').hasError('required')">El EndPoint es
                    requerido.</mdb-error>
                  <mdb-error *ngIf="formulario.get('endpoint').hasError('maxlength')">El EndPoint no puede superar los
                    100 caracteres.</mdb-error>
                  <mdb-error *ngIf="formulario.get('endpoint').hasError('minlength')">El EndPoint debe tener como mínimo
                    5 caracteres.</mdb-error>
                </div>
              </div>
              <div class="row">
                <div class="col-auto">
                  <div class="md-form">
                    <input value="" formControlName="orden" type="number" step="1" id="aorden" placeholder="Orden" required
                      #rol maxlength="50" />
                    <label for="veorden">Orden</label>
                    <div *ngIf="
                        formulario.get('orden').invalid &&
                        (formulario.get('orden').dirty ||
                          formulario.get('orden').touched)
                      ">
                      <mdb-error *ngIf="formulario.get('orden').hasError('required')">El Orden es requerido.</mdb-error>
                      <mdb-error *ngIf="formulario.get('orden').hasError('min')">El Orden no puede ser cero.</mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <mdb-checkbox formControlName="habilitar_bloqueo">Habilitar bloqueo concurrencia</mdb-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <mdb-select formControlName="operacion" label="Operacion" [options]="optionsOperacion"
                      placeholder="Operacion">
                    </mdb-select>
                  </div>
                </div>
                <div class="col">
                  <button type="button" mdbBtn color="info" mdbWavesEffect (click)="agregarOperacion()">
                    Agregar
                  </button>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-striped table-hover table-sm align-middle">
                  <thead class="grey lighten-2">
                    <tr>
                      <th scope="col">Operacion</th>
                      <th scope="col">Fecha de asignación</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="
                        !operacionModuloList || operacionModuloList.length === 0
                      ">
                      <td colspan="7" style="text-align: center">
                        Agregué Operacion
                      </td>
                    </tr>
                    <tr *ngFor="let ope of operacionModuloList; let i = index">
                      <td>{{ ope.operacion_nombre }}</td>
                      <td>{{ ope.fecha_creacion | date: "dd/MM/yyyy" }}</td>
                      <td>
                        <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                          (click)="eliminarOperacion(i)">
                          <mdb-icon fas icon="trash"></mdb-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="agregarModulo.hide()"
            mdbWavesEffect>
            Cerrar
          </button>
          <button class="btn btn-secondary waves-light" mdbWavesEffect type="submit" [disabled]="formulario.invalid">
            Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- MODAL Editar rol -->
<div mdbModal #editarModulo="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formulario" (ngSubmit)="actualizar(operacionModuloList); editarModulo.hide()">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Editar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="editarModulo.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <h5 class="modal-title w-100 text-left" id="myModalLabel">
                Datos de módulo
              </h5>
            </div>
            <div class="col">
              <div class="switch info-switch">
                <label>Inactivo<input formControlName="activado" type="checkbox" color="info" checked="" /><span
                    class="lever"></span>Activo</label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input value="" formControlName="nombre" type="text" id="emodulo" class="form-control"
                  placeholder="Módulo" required #rol maxlength="50" />
                <label for="vecodigo">Módulo</label>
                <div *ngIf="
                    formulario.get('nombre').invalid &&
                    (formulario.get('nombre').dirty ||
                      formulario.get('nombre').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('nombre').hasError('required')">El Nombre es requerido.</mdb-error>
                  <mdb-error *ngIf="formulario.get('nombre').hasError('maxlength')">El Nombre no puede superar los 50
                    caracteres.</mdb-error>
                  <mdb-error *ngIf="formulario.get('nombre').hasError('minlength')">El Nombre debe tener como mínimo 5
                    caracteres.</mdb-error>
                </div>
              </div>
              <div class="md-form">
                <input value="" formControlName="endpoint" type="text" id="eendpoint" class="form-control"
                  placeholder="Endpoint" required #endpoint maxlength="100" />
                <label for="endpoint">Endpoint</label>
                <div *ngIf="
                    formulario.get('endpoint').invalid &&
                    (formulario.get('endpoint').dirty ||
                      formulario.get('endpoint').touched)
                  ">
                  <mdb-error *ngIf="formulario.get('endpoint').hasError('required')">El EndPoint es
                    requerido.</mdb-error>
                  <mdb-error *ngIf="formulario.get('endpoint').hasError('maxlength')">El EndPoint no puede superar los
                    100 caracteres.</mdb-error>
                  <mdb-error *ngIf="formulario.get('endpoint').hasError('minlength')">El EndPoint debe tener como mínimo
                    5 caracteres.</mdb-error>
                </div>
              </div>
              <div class="row">
                <div class="col-auto">
                  <div class="md-form">
                    <input value="" formControlName="orden" type="number" step="1" id="eorden" placeholder="Orden" required
                      #rol maxlength="50" />
                    <label for="veorden">Orden</label>
                    <div *ngIf="
                        formulario.get('orden').invalid &&
                        (formulario.get('orden').dirty ||
                          formulario.get('orden').touched)
                      ">
                      <mdb-error *ngIf="formulario.get('orden').hasError('required')">El Orden es requerido.</mdb-error>
                      <mdb-error *ngIf="formulario.get('orden').hasError('min')">El Orden no puede ser cero.</mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <mdb-checkbox formControlName="habilitar_bloqueo">Habilitar bloqueo concurrencia</mdb-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <mdb-select formControlName="operacion" label="Operacion" [options]="optionsOperacion"
                      placeholder="Operacion">
                    </mdb-select>
                  </div>
                </div>
                <div class="col">
                  <button type="button" mdbBtn color="info" mdbWavesEffect (click)="agregarOperacion()">
                    Agregar
                  </button>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-striped table-hover table-sm align-middle">
                  <thead class="grey lighten-2">
                    <tr>
                      <th scope="col">Operacion</th>
                      <th scope="col">Fecha de asignación</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="
                        !operacionModuloList || operacionModuloList.length === 0
                      ">
                      <td colspan="7" style="text-align: center">
                        Agregué Operacion
                      </td>
                    </tr>
                    <tr *ngFor="let ope of operacionModuloList; let i = index">
                      <td>{{ ope.operacion_nombre }}</td>
                      <td>{{ ope.fecha_creacion | date: "dd/MM/yyyy" }}</td>
                      <td>
                        <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                          (click)="eliminarOperacion(i)" mdbTooltip="Eliminar">
                          <mdb-icon fas icon="trash"></mdb-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="editarModulo.hide()"
              mdbWavesEffect>
              Cerrar
            </button>
            <button class="btn btn-secondary waves-light" mdbWavesEffect type="submit" [disabled]="formulario.invalid">
              Guardar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>